import { Dimensions } from '../shared/component-height/component-dimensions.constants';

export function getQrCodeHeight(dimensions: Dimensions | undefined) {
  let height = Number(dimensions?.height || 0) / 2;
  if (height > 100) {
    height = 100;
  }
  if (height < 64) {
    height = 64;
  }
  return height;
}
